import { Box, HStack, Pressable, VStack, useMediaQuery } from 'native-base';
import CommonHeading from '../../../components/headings';
import {
  dashboardSVG,
  fileSVG,
  imageSVG,
  starSVG,
  travelSVG,
  walletSVG
} from '../../../utils/svg';
import { useSelector } from 'react-redux';
import CryptoJS from 'crypto-js';
import config from '../../../utils/config';
import ContainerCards from '../../../components/cards';
import { COLORS } from '../../../utils/colors';
import { MOBILE_VIEW_WIDTH } from '../../../utils/screens';
import QuickLinksCards from '../../../containers/quickLinksCards';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { hasPermission } from '../../../utils/permission';
import { Svg, Text } from 'react-native-svg';
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from '../../../utils/fonts';

const QuickLinks = () => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH
  });
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const isCoordinator = useSelector((state) => state.user.isCoordinator);
  const eventTab = activeTab === 'event' ? 'EVENT' : 'MICE';
  
  // Get user info from session storage
  const bytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem('content'),
    config.userKey
  );
  const jsonString = bytes.toString(CryptoJS.enc.Utf8);
  const userInfo = JSON.parse(jsonString);
  
  // Check if user is admin or initiator
  const isAdminOrInitiator = hasPermission('ADMIN') || userInfo.role === 'initiator';
  const linkData = [
    // hasPermission('LANDING_PAGE') && hasPermission('COST_BENCHMARKING') && {
    //   name: 'COST BENCHMARKING',
    //   svg: dashboardSVG,
    //   url: '/cost-benchmark'
    // },
    hasPermission('LANDING_PAGE') &&
    hasPermission('SHOW_POLICY') && {
      name: 'POLICIES & DOCUMENTS',
      svg: fileSVG,
      url: '/policy'
    },
    hasPermission('LANDING_PAGE') &&
    hasPermission('SHOW_POLICY') && {
      name: `${eventTab} PARTNER`,
      svg: travelSVG,
      url: '/travel-partners'
    },
    hasPermission('LANDING_PAGE') && {
      name: 'IMAGES',
      svg: imageSVG,
      url: '/images'
    },
    hasPermission('LANDING_PAGE') && {
      name: 'REVIEWS',
      svg: starSVG,
      url: '/reviews'
    },
    hasPermission('LANDING_PAGE') && {
      name: 'WALLET',
      svg: walletSVG,
      url: '/wallets'
    },
    // hasPermission('LANDING_PAGE') && isCoordinator && isAdminOrInitiator && {
    //   name: 'SURVEY FORM',
    //   svg: fileSVG,
    //   url: '/survey-forms'
    // },
    hasPermission('ADMIN') && {
      name: 'ARCHIVE FOLDER',
      svg: imageSVG,
      url: '/archive-folder'
    },
    hasPermission('ADMIN')
      ? {
        name: 'DASHBOARD',
        svg: dashboardSVG,
        url: '/dashboard'
      }
      : {
        name: '',
        svg: '',
        url: ''
      },
    hasPermission('ADMIN')
      ? {
        name: 'USERS LISTING',
        svg: travelSVG,
        url: '/users'
      }
      : {
        name: '',
        svg: '',
        url: ''
      },
    hasPermission('ADMIN')
      ? {
        name: 'USER ACCESS REQUESTS',
        svg: travelSVG,
        url: '/user-access-requests'
      }
      : {
        name: '',
        svg: '',
        url: ''
      },
    hasPermission('ADMIN')
      ? {
        name: 'QUOTATION REQUESTS',
        svg: travelSVG,
        url: '/quotation-requests'
      }
      : {
        name: '',
        svg: '',
        url: ''
      },
      hasPermission('ADMIN')
      ? {
        name: 'BENCHMARK DATA',
        svg: dashboardSVG,
        url: '/benchmark-data'
      }
      : {
        name: '',
        svg: '',
        url: ''
      },
  ];

  // Filter out empty items and calculate dynamic width
  const visibleCards = linkData?.filter(item => item && item.name);

  // Calculate dynamic width based on number of visible cards
  const getCardWidth = () => {
    if (MobileWindow) {
      return '47%'; // Keep mobile layout as is
    }

    // For desktop, calculate width based on number of visible cards
    const cardCount = visibleCards?.length || 0;

    if (cardCount === 1) return '98%'; // Single card takes almost full width
    if (cardCount === 2) return '49%'; // Two cards split the space
    if (cardCount === 3) return '32%'; // Three cards with equal spacing
    if (cardCount === 4) return '24%'; // Four cards with equal spacing
    return '19%'; // Five or more cards use standard 5-per-row layout
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <VStack space={5}>
      <Box alignItems={'center'}>
        <CommonHeading text='Quick Link' />
      </Box>
      <HStack
        w='100%'
        flexWrap={'wrap'}
        justifyContent={MobileWindow ? 'space-between' : (visibleCards?.length < 5 ? 'center' : 'space-between')}
        style={{ rowGap: '0.32rem' }}
      >
        {visibleCards?.map((item, index) => {
          return (
            <Box
              width={getCardWidth()}
              height={MobileWindow ? '108px' : '105px'}
              borderRadius={'8px'}
              background={COLORS.WHITE_COLOR}
              mr={MobileWindow ? '0' : '1%'}
              mb={MobileWindow ? '17px' : '1.5rem'}
              key={index}
              margin={!hasPermission('LANDING_PAGE') && 'auto'}
            >
              <Link
                to={item.url}
                style={{
                  textDecoration: 'none',
                  display: 'block',
                  height: '100%'
                }}
                onClick={() => scrollToTop()}
              >
                <ContainerCards
                  width='100%'
                  height='100%'
                >
                  <QuickLinksCards
                    text={item.name}
                    svg={item.svg}
                  />
                </ContainerCards>
              </Link>
            </Box>
          );
        })}
      </HStack>
      {/* {hasPermission("LANDING_PAGE") && !hasPermission("REVIEW") ? (
        <HStack justifyContent="space-between" w="100%" flexWrap={"wrap"}>
          {linkData.map((item, index) => {
            return (
              item.name && (
                <Box
                  width={
                    MobileWindow
                      ? "47%"
                      : hasPermission("DASHBOARD")
                      ? "16%"
                      : "18%"
                  }
                  height={MobileWindow ? "108px" : "105px"}
                  borderRadius={"8px"}
                  background={COLORS.WHITE_COLOR}
                  mr={MobileWindow ? "5px" : undefined}
                  mb={MobileWindow ? "17px" : undefined}
                  key={index}
                  margin={!hasPermission("LANDING_PAGE") && "auto"}
                >
                  <Link
                    to={item.url}
                    style={{
                      textDecoration: "none",
                      display: "block",
                      height: "100%",
                    }}
                    onClick={() => scrollToTop()}
                  >
                    <ContainerCards width="100%" height="100%">
                      <QuickLinksCards text={item.name} svg={item.svg} />
                    </ContainerCards>
                  </Link>
                </Box>
              )
            );
          })}
        </HStack>
      ) : (
        hasPermission("LANDING_PAGE") &&
        hasPermission("REVIEW") && (
          <HStack justifyContent="space-between" w="100%" flexWrap={"wrap"}>
            {linkData.map((item, index) => {
              return (
                item.name && (
                  <Box
                    width={"49%"}
                    height={MobileWindow ? "108px" : "105px"}
                    borderRadius={"8px"}
                    background={COLORS.WHITE_COLOR}
                    mr={MobileWindow ? "5px" : undefined}
                    key={index}
                  >
                    <Link
                      to={item.url}
                      style={{
                        textDecoration: "none",
                        display: "block",
                        height: "100%",
                        color: COLORS.PARTNERS_HEADING_COLOR,
                      }}
                      onClick={() => scrollToTop()}
                    >
                      <ContainerCards width="100%" height="100%">
                        <QuickLinksCards text={item.name} svg={item.svg} />
                        <HStack
                          flex={1}
                          p={4}
                          ml={2}
                          justifyContent={"center"}
                          alignItems={"center"}
                        >
                          <Svg width="67" height="67" viewBox="0 0 37 27">
                            {item.svg}
                          </Svg>
                          <Text
                            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                            fontSize={COMMONFONTSIZE.LARGE_MEDIUM_FONT_SIZE}
                            color={COLORS.PARTNERS_HEADING_COLOR}
                          >
                            {item.name}
                          </Text>
                        </HStack>
                      </ContainerCards>
                    </Link>
                  </Box>
                )
              );
            })}
          </HStack>
        )
      )} */}
    </VStack>
  );
};

export default QuickLinks;
